export const InitSurveyCreatorConfig = () => {
  console.log("Initializing Survey Creator Config");

  if (appConfig.surveyJsKey) {
    window.Survey.slk(appConfig.surveyJsKey);
  }

  window.SurveyCreatorCore.getLocaleStrings("en").qt.text = "Single Line Answer";
  window.SurveyCreatorCore.getLocaleStrings("en").qt.comment = "Long Text Response";
  window.SurveyCreatorCore.getLocaleStrings("en").qt.multipletext = "Multiple Text Fields";
  window.SurveyCreatorCore.getLocaleStrings("en").qt.radiogroup = "Single Choice";
  window.SurveyCreatorCore.getLocaleStrings("en").qt.checkbox = "Multi Choice";
  window.SurveyCreatorCore.getLocaleStrings("en").qt.rating = "Rating";
  window.SurveyCreatorCore.getLocaleStrings("en").qt.dropdown = "Single Choice Dropdown";
  window.SurveyCreatorCore.getLocaleStrings("en").qt.tagbox = "Multi Choice Dropdown";
  window.SurveyCreatorCore.getLocaleStrings("en").qt.panel = "Section";
  window.SurveyCreatorCore.getLocaleStrings("en").qt.matrix = "Single Choice Matrix";
  window.SurveyCreatorCore.getLocaleStrings("en").qt.matrixdropdown = "Multi Choice Matrix";
  window.SurveyCreatorCore.getLocaleStrings("en").qt.ranking = "Ranking";
  window.SurveyCreatorCore.getLocaleStrings("en").qt.slider = "Slider";
};
